import { render, staticRenderFns } from "./TicoursesCreate.vue?vue&type=template&id=0ab124a8"
import script from "./TicoursesCreate.vue?vue&type=script&lang=js"
export * from "./TicoursesCreate.vue?vue&type=script&lang=js"
import style0 from "./TicoursesCreate.vue?vue&type=style&index=0&id=0ab124a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports